export default {
  SATABAPP_STORE: ({commit}, payload) => {
    localStorage.setItem(payload.key, JSON.stringify(payload.val));
    commit('SATABAPP_STORE', payload);
  },
  SATABAPP_LOAD: ({commit}) => {
    Object.entries(localStorage).map((entrie) => {
      if(entrie[0].startsWith("satabapp-"))  {
        commit('SATABAPP_STORE', {key: entrie[0], val: JSON.parse(entrie[1])});
      }
    });
  },
  SATABAPP_RESET: ({commit}) => {
    commit('SATABAPP_RESET')
  },
};